module.exports = __webpack_public_path__ + "media/images/icons/map/origin-9cb2528d2a6bbcab6d682ee5e6d94f05.svg";